import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AppThemeProvider } from './hooks/theme';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
